<template>
    <div class="headnav u-flex u-flex--space-between u-flex--vertical-center">
        <h1>
            <img v-if="$route.name === 'Home'" class="headnav__logo u-block" src="@/assets/logo.png" :alt="appName" title="" />
            <router-link v-else :to="{ name: 'Home' }" class="text-white u-no-underline">
                <img class="headnav__logo u-block" src="@/assets/logo.png" :alt="appName" title="" />
            </router-link>
        </h1>
        <div v-if="isLoggedIn">
            <el-button type="text" @click="logout">Logout</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeadNav',

    computed: {
        appName () {
            return process.env.VUE_APP_NAME
        },

        isLoggedIn () {
            return this.$store.getters.isLoggedIn
        },
    },

    methods: {
        async logout () {
            try {
                await this.$store.commit('setUser', null)
                await this.$appwrite.account.deleteSessions()
                await this.$router.push({ name: 'Login' })
            } catch (error) {
                this.$notify({
                    title: 'Error',
                    message: error.message,
                    type: 'error',
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.headnav {
    position: sticky;
    z-index: $index-above;
    top: 0;
    left: 0;
    max-width: 100vw;
    height: $headnav-height;
    background-color: $head-nav-background-color;
    color: $head-nav-text-color;
    padding: $spacing-unit-16;

    &__logo {
        width: 30vw;
        height: auto;
        max-height: $headnav-height;
        object-fit: contain;
        object-position: left;
    }
}
</style>
